export default "/_next/static/images/favicon-6ade037e067f752a973cf8dc96eb6e1a.png";